import { render, staticRenderFns } from "./InsureApplyView.vue?vue&type=template&id=5603209a&scoped=true&"
import script from "./InsureApplyView.vue?vue&type=script&lang=js&"
export * from "./InsureApplyView.vue?vue&type=script&lang=js&"
import style0 from "./InsureApplyView.vue?vue&type=style&index=0&id=5603209a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5603209a",
  null
  
)

export default component.exports